module.exports = __webpack_public_path__ + "img/34a7967.png";